import { Card, CardContent } from "@/components/ui/card";
import { Quote } from "lucide-react";
import ahsanImage from "@/assets/ahsan-sajid.png";

interface QuoteCardProps {
  image: string;
  name: string;
  title: string;
  quote: string;
}

const QuoteCard = ({ image, name, title, quote }: QuoteCardProps) => (
  <Card className="bg-card border-border/50">
    <CardContent className="p-6 sm:p-8">
      <div className="flex flex-col sm:flex-row gap-6 items-start">
        <div className="shrink-0">
          <div className="relative">
            <img
              src={image}
              alt={`${name}, ${title}`}
              className="w-16 h-16 sm:w-20 sm:h-20 rounded-full object-cover border-2 border-primary/20"
            />
            <div className="absolute -top-2 -right-2 p-1.5 rounded-full bg-primary/20">
              <Quote className="w-3 h-3 text-primary" />
            </div>
          </div>
        </div>
        
        <div className="space-y-4">
          <blockquote className="text-lg sm:text-xl text-foreground leading-relaxed italic">
            "{quote}"
          </blockquote>
          
          <div className="flex flex-col">
            <span className="font-semibold text-foreground">{name}</span>
            <span className="text-sm text-muted-foreground">{title}</span>
          </div>
        </div>
      </div>
    </CardContent>
  </Card>
);

export const PMToolsFounderQuote = () => {
  return (
    <section className="py-8">
      <QuoteCard
        image={ahsanImage}
        name="Ahsan Sajid"
        title="Owner, IT Dukes"
        quote="Most teams overpay for project management tools because they don't realize how much feature gating costs them. Lottae's transparent pricing model — a flat base fee plus per-user costs — means a 25-person team pays $110/month for everything. With competitors, you'd pay $250+ and still lack white-labeling."
      />
    </section>
  );
};
